// extracted by mini-css-extract-plugin
export default {"cardContainer":"GridCard_cardContainer__Wh6fI","imgContainer":"GridCard_imgContainer__FtwJR","textSection":"GridCard_textSection__0sWUV"};